import React from "react";
import { useOutletContext } from "react-router-dom";
import { Button, CheckBoxInput, DownloadAgreement } from "@/components";
import { IoArrowForward } from "react-icons/io5";
import { useState } from "react";
import { useAlert } from "@/";

const SellerAgreement = () => {
  const { alert, AlertDialog } = useAlert();
  const { handleSubmit, handlePreviousStep, isDisabled } = useOutletContext(); // Get handleNextStep from context
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [sellerAgreement, setSellerAgreement] = useState(false);

  const handleSendForVerification = (e) => {
    e.preventDefault();
    if (termsAndConditions && sellerAgreement) {
      handleSubmit();
    } else {
      alert("Please accept the terms & conditions and seller agreement.");
    }
  };

  return (
    <div className="flex flex-col gap-4 md:gap-4 p-2">
      <div>
        <h2 className="md:text-headline3 text-headline4 font-nunito text-secondary-90 font-bold">
          Seller Agreement
        </h2>
        <p className="text-body2 md:text-body1 text-secondary/60 font-ptsans w-full md:w-[60%]">
          Download the agreement form, fill it out by hand, create a PDF, and
          then upload it back below.
        </p>
      </div>
      <DownloadAgreement disabled={isDisabled} />
      <form onSubmit={handleSendForVerification}>
        <div className="flex flex-col gap-2 pl-2 mt-2">
          <CheckBoxInput
            label="I have read the terms and conditions of the Seller Agreement."
            labelClassName="text-caption md:text-body1 line-clamp-1 md:line-clamp-none"
            checked={termsAndConditions}
            onChange={setTermsAndConditions}
            disabled={isDisabled}
          />

          <CheckBoxInput
            label="By proceeding, I agree to the Seller Agreement terms and policies."
            checked={sellerAgreement}
            labelClassName="text-caption md:text-body1 line-clamp-1 md:line-clamp-none"
            onChange={setSellerAgreement}
            disabled={isDisabled}
          />
        </div>
      </form>

      <div className="flex flex-row gap-1 md:gap-2 justify-between sm:justify-end mt-8 mr-2">
        <Button size="sm" variant="outline" onClick={handlePreviousStep}>
          Previous
        </Button>
        {!isDisabled && (
          <Button
            size="sm"
            variant="default"
            onClick={handleSendForVerification}
            icon={IoArrowForward}
          >
            Submit For Verification
          </Button>
        )}
      </div>
      <AlertDialog />
    </div>
  );
};

export default SellerAgreement;
